import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, useToast, Checkbox, Text,useColorModeValue, HStack, Flex, Image } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { FiEdit, FiCheck, FiX } from "react-icons/fi";
import PrivateContentLayout from '../Common/PrivateContentLayout';
import { Tenant } from "../Common/types";
import { useNavigate } from "react-router-dom";



const TenantManager = () => {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  const [newTenant, setNewTenant] = useState<Tenant | null>(null);
  const toast = useToast();
    const navigate = useNavigate();

  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const fetchTenants = async () => {
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(tenantsapiurl,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setTenants(response.data);
    } catch (error) {
      console.error("Failed to load tenants", error);
    }
  };
  const handleReviewTenant = (tenant_id: number) => {
    // Placeholder function
    
  
      navigate(`/platform/super/tenant-manager/review-tenant/${tenant_id}`);
    
      
  };


  const handleAddNewTenant = () => {
    const tenant_id=0;
    navigate(`/platform/super/tenant-manager/review-tenant/${tenant_id}`);
  
  };

  useEffect(() => {
    fetchTenants();
  }, []);

  return (
    <Box as="main" mx="auto" p={10} >
    
        <VStack>
        <Heading size={"md"}>Tenant Manager</Heading>
        </VStack>
        
        <Box mt={4}>
            <Text fontWeight="bold">Tenant Details</Text>
          <Button mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewTenant}>
            + Tenant
          </Button>
        </Box>
        
      <Box mt={4}>
      <Text fontWeight="bold">Tenant Details</Text>
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead>
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Logo</Th>
              <Th>Name</Th>
              <Th>Description</Th>
              <Th>Active</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="sm">
            {tenants.map((tenant) => (
              <Tr key={tenant.tenant_id}>
                <Td>{tenant.tenant_id}</Td>
                <Td>
                                                {/* Logo */}
                            <Flex justify="center" mb={6}>
                                <Image
                                src={tenant.logo_image_url}
                                alt={`${tenant.name} logo`}
                                boxSize={{ base: "30px", md: "50px" }}
                                objectFit="contain"
                                borderRadius="md"
                                />
                            </Flex>
                            </Td>
                <Td>
                  {
                    tenant.name}
                </Td>
                <Td>
              
                    {tenant.description
                  }
                </Td>
                <Td>
                  {tenant.is_active ? "Active" : "Inactive"}
                </Td>
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewTenant(tenant.tenant_id)}>
                      Review Tenant
                    </Button>
                  </Tooltip>
                </Td>

              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
 
      </Box>
    
  );
};

export default TenantManager;